// extracted by mini-css-extract-plugin
export default {"notFound":"css_notFound__fsCWh","eyebrow":"css_eyebrow__st1sl","title":"css_title__8BYQZ","text":"css_text__vyvWo","cta":"css_cta__73AS1"};